export default {
    repairPolygon: 'Error trying to repair polygon..',
    passwordChanged: 'Your password changed',
    reset: 'A reset link has been sent to your email',
    activationLink: 'An activation link has been sent to your email',
    detailsChanged: 'Your details changed',

    artefactInfo: 'No changes to save',
    artefactSuccess: 'Artefact Saved',
    artefactError: 'Saving Artefact Failed',
    artefactsAutoModeError: 'Auto mode is not possible when more than one letter is selected',

    editionSuccess: 'Edition renamed',
    editionError: 'Edition rename failed',

    editionDeleteSuccess: 'Edition deleted',
    editionDeleteError: 'Edition delete failed',

    invitationSent: 'Invitation sent to {email}',
    permissionsUpdated: 'Permissions of {email} updated',

    NoChangesDetected: 'No changes detected',
    imagedObjectFailed: 'Imaged Object Save Failed',
    imagedObjectSaved: 'Imaged Object Saved',

    artefactCreated: 'Artefact Created',
    artefactCreatedFailed: 'Artefact creation failed',

    artefactRenamed: 'Artefact renamed',
    artefactRenameFailed: 'Artefact rename failed',

    artefactDeleted: 'Artefact deleted',
    deleteArtefactFailed: 'Delete artefact failed',
    artefactCantOverlap: "Artefact can't overlap other artefacts",

    attributeDeletedBySomeoneElse: 'Attribute was deleted by another user'
};

